import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";
import { ChangeQItem } from "../../../core/services/sync-up/item";
import { Response } from "@angular/http";

export interface ISyncUpItemArgs extends IAccountObjectArgs {
    changeQItem: ChangeQItem;
    response?: Response;
}

const defaults = () => ({
    changeQItem: undefined,
    response: undefined
});

export class SyncUpItem extends AccountObject {
    changeQItem: ChangeQItem;
    response: Response;

    constructor(data?: ISyncUpItemArgs) {
        data.id = data.changeQItem.key;
        super({...defaults(), ...data} as any);
    }

    get hasResponse(): boolean {
        return !!this.response;
    }

    get ok(): boolean {
        return this.response && this.response.ok;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/sync-up-item/sync-up-item.model.ts